import gql from 'graphql-tag'

export const GET_ORGANIZATION_SUBSCRIBERS = gql`
  query getOrganizationSubscribers($organizationSlug: String!, $pagination: Pagination!) {
    getOrganizationSubscribers(organizationSlug: $organizationSlug, pagination: $pagination)
  }
`

export const DELETE_SUBSCRIBERS = gql`
  mutation DeleteSubscribers($organizationSlug: String!, $ids: [Int!]!) {
    deleteSubscribers(organizationSlug: $organizationSlug, ids: $ids)
  }
`
